import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { finalize, map, shareReplay, takeUntil } from 'rxjs/operators';
import { ContentState } from 'src/app/store/state/content.state';
import { ERPX_FILE_URL } from 'src/app/app.constants'; 
import { AppService } from 'src/app/services/app.service';
import { HippoContentService } from 'src/app/services/hippo-content.service';
import { ErrorHandlerUtil } from 'src/app/utils/error-handler.util';
import { DomSanitizer } from '@angular/platform-browser';
import { Modal } from 'src/app/models/modal.model';
import { ContentDocument } from 'src/app/models/content-document.model';

@Component({
    selector: 'u4-cpp-download',
    templateUrl: './download.component.html',
    styles: [
    ]
})
export class DownloadComponent implements OnInit, OnDestroy {

    public labels: {[key: string]: string};
    public erpxFileUrl: string;
    content: Observable<Modal>;
    isOpen: boolean;
    private destroy$: Subject<void> = new Subject();
    
    constructor(
        protected store: Store<ContentState>,
        protected appService: AppService,
        private hippoContentService: HippoContentService,
        private errorHandlerUtil: ErrorHandlerUtil,
        private domSanitizer: DomSanitizer
    ){
        this.isOpen = false;
        this.erpxFileUrl = ERPX_FILE_URL;
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);
    }

    ngOnInit(value= 'download-erpx-description'): void { 
        if (typeof value === 'string') {
            this.content = this.getModalContent(value).pipe( finalize(() => {
            }));
            this.content.pipe(
                takeUntil(this.destroy$)
            ).subscribe(
                (success) => this.isOpen = !!success,
                (error: Error) => this.errorHandlerUtil.handleError(error)
            );
        }
        this.clickDownloadFunction();  
    }

    getModalContent(contentPath: string): Observable<Modal> {
        return this.hippoContentService.getContentDocument(contentPath).pipe(
            map((contentDocument: ContentDocument) => new Modal({
                title: contentDocument.title,
                body: this.domSanitizer.bypassSecurityTrustHtml(contentDocument.content)

            })),
            shareReplay(1)
        );
    }

    clickDownloadFunction(): void {
        document.getElementById('cpp-download-file').click();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
